import React, { Component } from 'react';
import 'assets/scss/header.css';

import Toaster from '../Toaster';
import AddCreditCardModal from '../Modal/creditCard/addCreditCard';
import AddCardSuccessModal from '../Modal/creditCard/addCardSuccess';
import {
  getUserData,
  getBusinessId,
} from '../../constants/localStorageManager';
import { formatExpiryDate } from '../../utils/date';
import BusinessApi from '../../apis/Business';

class ChargeFailedBanner extends Component {
  constructor() {
    super();
    this.state = {
      businessId: '',
      businessName: '',
      successModalContent: {},
      billingCard: {},
    };
  }

  componentDidMount() {
    this.checkCreditDetails();
  }

  checkCreditDetails = () => {
    BusinessApi.getDetails(getBusinessId()).then(({ data }) => {
      const { billing_addresses: billingAddresses, name } = data;
      const billingCard =
        billingAddresses.find(billingAddress => billingAddress.is_primary) ||
        {};
      this.setState({ billingCard, businessName: name });
    });
  };

  setCardModalVisible = visibility => {
    this.setState({ cardModalVisible: visibility });
  };

  setSuccessModalVisibility = visibility => {
    this.setState({ successModalVisible: visibility });
  };

  setSuccessModalContent = () => {};

  render() {
    const {
      businessName,
      successModalVisible,
      cardModalVisible,
      successModalContent,
      billingCard,
    } = this.state;
    const billingAddresses = [];
    const userData = getUserData() || { businesses: [{}] };
    const businessData = userData.businesses[0];
    const {
      id: businessId,
      display_payment_failed_banner,
      last_charge_attempt,
      next_charge_attempt,
    } = businessData;

    if (!display_payment_failed_banner) return null;

    return (
      <React.Fragment>
        <AddCreditCardModal
          isVisible={cardModalVisible}
          billingAddresses={billingAddresses}
          businessId={businessId}
          toggleSuccessModal={(data = {}) => {
            this.setSuccessModalVisibility(!successModalVisible);
            this.setSuccessModalContent(data);
          }}
          onCancel={() => this.setCardModalVisible(false)}
          editModal
          billingCardId={billingCard.id}
        />
        <AddCardSuccessModal
          businessName={businessName}
          isVisible={successModalVisible}
          modalContent={successModalContent}
          toggleSuccessModal={(data = {}) => {
            this.setSuccessModalVisibility(!successModalVisible);
            this.setSuccessModalContent(data);
          }}
          fetchBusinessDetail={() => {}}
        />
        <div className="top-message-banner">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mx-auto">
                <p className="pt-3 d-inline mr-5">
                  We were unable to charge your credit card on{' '}
                  {formatExpiryDate(last_charge_attempt)}. We will attempt to
                  charge your account again on{' '}
                  {formatExpiryDate(next_charge_attempt)}. You may need to
                  upgrade your credit card information to continue.
                </p>
                <button
                  className="btn ml-4 mx-auto"
                  onClick={() => this.setCardModalVisible(true)}
                >
                  Manage Payment Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ChargeFailedBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/chargeFailed.js